import { useQuery } from '@tanstack/react-query';
import configurationService, { getConfigurationBooleanFieldValue } from '@Services/configurationService';

const SINIESTROS_QUERY_KEY = ['configuration', 'siniestros-menu'];

export const fetchSiniestrosMenuEnabled = async ({ signal }) => {
	try {
		const response = await configurationService.getConfiguration('siniestros-menu', {
			auth: true,
			signal
		});
		return getConfigurationBooleanFieldValue(response, 'enabled', true);
	} catch {
		return false;
	}
};

const enableSiniestrosMenu = () => {
	const { data: isSiniestrosMenuEnabled = true, isLoading: siniestrosMenuLoading } = useQuery({
		queryKey: SINIESTROS_QUERY_KEY,
		queryFn: fetchSiniestrosMenuEnabled
	});

	return { isSiniestrosMenuEnabled, siniestrosMenuLoading };
};

export default enableSiniestrosMenu;